import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 39"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "19.5",
      cy: "19.5",
      r: "7.367",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M19.5 14.4v5.1h3.967"
    }, null, -1),
    _createElementVNode("rect", {
      width: "38",
      height: "38",
      x: ".5",
      y: ".5",
      stroke: "currentColor",
      rx: "19"
    }, null, -1)
  ]))]))
}
export default { render: render }